import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, ConfigProvider, Flex } from '@app/ui';
import './SocialBenchmarking.scss';

type RankContainerProps = {
    children?: React.ReactNode;
};

const HighlightsRankContainer = ({ children }: RankContainerProps) => {
    const { t } = useTranslation('benchmarking');
    const [isExpanded, setIsExpanded] = useState(false);
    const titleContent = (
        <Flex>
            <Flex
                gap={12}
                justify="center"
                align="center"
                className="-m-r-2"
                style={{
                    height: 'fit-content',
                    fontSize: 14,
                }}
            >
                {t('socialBenchmarking.ranking.title')}
            </Flex>
        </Flex>
    );

    return (
        <ConfigProvider
            theme={{
                components: {
                    Collapse: {
                        headerBg: '#FAFAFA',
                        colorBorder: '#BFBFBF',
                    },
                },
            }}
        >
            <Collapse
                style={{
                    top: 0,
                    overflow: 'hidden',
                    width: '100%',
                }}
                activeKey={isExpanded ? ['1'] : []}
                onChange={() => setIsExpanded(!isExpanded)}
                expandIconPosition="start"
                items={[
                    {
                        key: '1',
                        label: titleContent,
                        children: (
                            <div className="highlights-rank-content">
                                {children}
                            </div>
                        ),
                    },
                ]}
            />
        </ConfigProvider>
    );
};

export default HighlightsRankContainer;
